<po-modal #poModalNewOrderCount [p-hide-close]="true" [p-primary-action]="primaryAction"
    [p-secondary-action]="secondaryAction" p-title="Nova Contagem">
    <div class="po-text-center po-font-text-large po-pt-2 po-pb-2">
        <div class="po-mb-1" style="border-bottom: 1px solid #d3d3d3;">
            <b class="add-dots">{{orderModel.orderCode }}</b>
        </div>
        <div [formGroup]="newOrderCountForm">
            <div class="po-xl-12 po-lg-12 po-md-12 po-sm-12">
                <p>Informe uma descrição para a <b>nova</b> contagem:</p>
                <po-input formControlName="orderCountDescription" [p-required]="'true'" p-placeholder="Digite algo"
                    p-type="text" [p-maxlength]="40" [ngClass]="{
                        'ng-touched ng-dirty ng-invalid': isOrderCountFormInvalid()
                      }">
                </po-input>
                <div *ngIf="isOrderCountFormInvalid()" class="invalid-form-text">
                    Necessário informar a descrição.
                </div>
            </div>
        </div>
    </div>
</po-modal>

<div class="po-row po-mb-1">
    <div class="po-xl-10 po-lg-10 po-md-9 po-sm-12">
        <p class="po-font-title">Contagens do Pedido</p>
    </div>
    <div class="po-xl-2 po-lg-2 po-md-2 po-sm-12 po-text-right po-mt-2">
        <app-filter-button (onClick)="onClick()" [seeFilter]="seeFilter"></app-filter-button>
    </div>
</div>
<app-filter-dropdown *ngIf="seeFilter" (onFilterClick)="onFilter()" (onCleanFilterClick)="cleanFilter()">
    <div class="po-xl-6 po-lg-5 po-md-12 po-sm-12">
        <p>Status</p>
        <po-select name="statusDefault" [ngModel]="itemFilter" [p-options]="statusItens"
            (p-change)="recoverStatusSelected($event)" p-placeholder="Selecione um status">
        </po-select>
    </div>
    <div class="po-xl-6 po-lg-5 po-md-12 po-sm-12">
        <p>Sequência da Contagem</p>
        <po-input (p-change)="setCountSequenceFilter($event)" type="number"
            p-placeholder="Digite a sequência da contagem" [p-maxlength]="20" [(ngModel)]="countSequenceFilter">
        </po-input>
    </div>
</app-filter-dropdown>

<div *ngIf="hasOpenCounts()" class="po-row po-mt-2">
    <div class="po-xl-12 po-lg-12 po-md-12 po-sm-12">
        <div class="po-p-2" style="background-color: #fff4ce; border-radius: 3px; border: 1px solid #ffeeba;">
            <p class="po-font-text po-text-center" style="color: #856404; margin: 0;">
                Você pode iniciar uma nova contagem clicando no botão "+".
            </p>
        </div>
    </div>
</div>

<po-widget class="po-lg-12 po-mb-2 po-mt-2">
    <div class="po-row po-pt-1">
        <div class="po-xl-12 po-lg-12 po-md-12 po-sm-12">
            <span class="po-text-color-01 po-font-text-bold add-2-dots" style="text-align: center;">Pedido:
                {{orderModel.orderCode }}</span>
        </div>
    </div>
</po-widget>
<div class="po-row po-mt-2 po-mb-5" [class.fade-in]="fadeInAnimation">
    <div class="po-row po-mb-5">
        <div class="po-mt-1 po-xl-1 po-lg-1 po-md-12 po-sm-12">
            <po-button p-kind="secondary" p-icon="an {{sortAsc ? 'an-sort-ascending': 'an-sort-descending'}}"
                (p-click)="changeSort()" class="po-text-center sort-button"></po-button>
        </div>
    </div>

    <div *ngIf="!nullFilter" class="po-xl-12 po-lg-12 po-md-12 po-sm-12">
        <app-order-count-list (orderCountSelected)="onOrderCountSelected($event)" [counts]="itemsListCountFilter" />
    </div>
    <div *ngIf="nullFilter" class="po-xl-12 po-lg-12 po-md-12 po-sm-12 po-text-center">
        <p>Nenhum item encontrado</p>
    </div>
</div>

<app-fixed-round-button *ngIf="showNewCountButton" [title]="'Nova contagem'" (onClick)="openModalNewOrderCount()" />